import React from "react";
// Customizable Area Start
import Dialog from "@material-ui/core/Dialog";
import { Radio, Input, styled, Box } from "@material-ui/core";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import PaymentModalController, {
  configJSON,
  IPaymentMethod,
} from "./PaymentModalController.web";
import { CustomSnackbar } from "../../../components/src/customComponents/CustomSnackbar.web";
import PromoCodePayment from "../../../blocks/Payments/src/PromoCodePayment.web";
import { loyaltyIcon, deamond, label } from "./assets";
import OtpPage from "../../otp-input-confirmation/src/Otp.web";
import { IOrder } from "../../OrderCreation/src/OrderCreationController.web";
import CircularProgress from "@material-ui/core/CircularProgress";
import { renderBaseOnConditions } from "../../../blocks/utilities/src/CustomBlockHelpers";
import lodash from "lodash";
import Cfwallet44 from "../../../blocks/cfwallet44/src/Cfwallet44.web";

const getCurrencyString = (currency: string, amount: number | string) => {
  return `${currency.toUpperCase()} ${amount}`;
};

// Customizable Area End

// Customizable Area Start

// Customizable Area End
export default class PaymentModal extends PaymentModalController {
  // Customizable Area Start
  renderUsablePoints() {
    const { currency, totalAmount, points } = this.state;

    return (
      <Cfwallet44
        navigation={undefined}
        id={""}
        currency={currency}
        totalAmount={totalAmount}
        points={points}
        isRenderUsablePoints={true}
        redeemPointsHandler={() => this.redeemAllPoints()}
      />
    );
  }

  renderAfterRedeem() {
    const { points, totalAmount, currency } = this.state;

    return (
      <Cfwallet44
        navigation={undefined}
        id={""}
        currency={currency}
        totalAmount={totalAmount}
        points={points}
        isRenderUsablePoints={false}
        usePointsHandler={() => this.useAmount()}
      />
    );
  }

  renderSecondPayments() {
    const { fromUnpaid } = this.props;
    const {
      activeTab,
      currency,
      remainBalance,
      customPaymentAmount,
      selectedSecondPaymentMethod,
      paymentMethods,
      walletBalance,
      goldenpointBalance,
      goldenpointApplicableBalance,
      expiredGoldenPoints,
      order,
      bonusPoints
    } = this.state;

    const paymentType = this.getSecondaryPaymentMethod()?.name;
    let totalPaidFromWalletAndPoints = 0;
    let gpToUse = goldenpointApplicableBalance;
    if (gpToUse > remainBalance) {
      gpToUse = remainBalance;
    }
    totalPaidFromWalletAndPoints = gpToUse;

    if (totalPaidFromWalletAndPoints < remainBalance) {
      let walletToUse = walletBalance;
      if (walletToUse > remainBalance - totalPaidFromWalletAndPoints) {
        walletToUse = remainBalance - totalPaidFromWalletAndPoints;
      }
      totalPaidFromWalletAndPoints += walletToUse;
    }

    // let amountLeftForSecondPayment = Math.max(remainBalance - totalPaidFromWalletAndPoints, 0 );
    let amountLeftForSecondPayment = Math.max(
      Number(remainBalance) - Number(customPaymentAmount),
      0
    );
    const isWalletSelected = this.state.paymentSource === "wallet";
    // const isGoldenPointSelected = this.state.shouldUseGoldenPoints === true;
    const isGoldenPointSelected = this.state.shouldUseGoldenPoints === true;
    let primarySource = "";
    let primaryAmountUsed = 0;

    if (isWalletSelected) {
      primarySource = "Wallet";
      primaryAmountUsed = Math.min(walletBalance, remainBalance);
    }

    if (isGoldenPointSelected) {
      primarySource = "Golden Points";
      const appliedDiscount = Number(order?.applied_discount ?? 0);
      const isGoldenBonusUsed = this.props?.order?.discount_summary?.is_golden_bonus_used || false;
      const goldenPointDiscount = isGoldenBonusUsed ? Number(this.latestAppliedDiscount ?? 0) : 0;
      if (goldenPointDiscount > 0) {
        // primaryAmountUsed = goldenpointApplicableBalance;
        primaryAmountUsed = goldenpointApplicableBalance - goldenPointDiscount;
      } else {
        primaryAmountUsed = Math.min(
          goldenpointApplicableBalance,
          remainBalance
        );
      }
    }
    const totalWalletBalance = goldenpointApplicableBalance + walletBalance;
    if (
      totalWalletBalance < remainBalance &&
      activeTab === 5 &&
      Number(primaryAmountUsed) < Number(remainBalance)
    ) {
      amountLeftForSecondPayment = Math.max(
        Number(remainBalance) - Number(primaryAmountUsed),
        0
      );

    }
    if (
      (totalWalletBalance < remainBalance ||
        isWalletSelected ||
        isGoldenPointSelected) &&
      activeTab === 5 &&
      Number(primaryAmountUsed) < Number(remainBalance)
    ) {

      if (Number(customPaymentAmount) !== Number(remainBalance)) {
        amountLeftForSecondPayment = Math.max(
          Number(remainBalance) - Number(customPaymentAmount),
          0
        );
      } else if (
        isGoldenPointSelected &&
        (Number(this.latestAppliedDiscount) > 0 ||
          this.state.latestAppliedDiscount > 0)
      ) {
        // const bas_point =
        //   Number(primaryAmountUsed || 0) -
        //   Number(this.latestAppliedDiscount || 0);
          const bas_point =
          Number(primaryAmountUsed || 0)
        amountLeftForSecondPayment = Math.max(
          Number(this.state.order?.total || 0) - Number(bas_point),
          0
        );
      } else {
        amountLeftForSecondPayment = Math.max(
          Number(remainBalance) - Number(primaryAmountUsed),
          0
        );
      }
    }
    if (amountLeftForSecondPayment <= 0 && this.state.secondPaymentEnabled) {
      amountLeftForSecondPayment = Number(customPaymentAmount);
    }
    const amountPayableString = `Amount payable from the ${String(
      paymentType ?? "second payment method"
    ).toLowerCase()} is ${getCurrencyString(
      currency,
      amountLeftForSecondPayment.toFixed(2)
    )}`;

    let secondPaymentMethods = JSON.parse(
      JSON.stringify(paymentMethods)
    ) as IPaymentMethod[];

    const secondEnablePaymentMethods = paymentMethods.map(
      (payment) => payment.name
    );

    secondPaymentMethods = secondPaymentMethods.map((item) => {
      if (secondEnablePaymentMethods.includes(item.name)) {
        item.enableSecond = true;
        return item;
      } else {
        return item;
      }
    });

    secondPaymentMethods = secondPaymentMethods.filter(
      (item) => item.id !== this.state.activeTab
    );

    // secondPaymentMethods = secondPaymentMethods.filter((item) => {
    //   const removeWallet = fromUnpaid
    //     ? item.name !== "Wallet" && item.name !== "Pay Later"
    //     : true;

    //   const notActiveTab =
    //     this.getPaymentMethodId(item.name || "") !== activeTab;
    //   return removeWallet && notActiveTab;
    // });

    secondPaymentMethods = secondPaymentMethods.filter((item) => {
    const removeWallet = fromUnpaid
      ? item.name !== "Wallet" && item.name !== "Pay Later"
      : true;

    const notActiveTab =
      this.getPaymentMethodId(item.name || "") !== activeTab;

      const removeRestrictedMethods = ![
        "Mokafaa",
        "Qitaf"
      ].includes(item.name || "");

      return removeWallet && notActiveTab && removeRestrictedMethods;
    });
    const { goldenPointList = [] } = this.props;

    return (
      <div
        className={"remainingPaymentContainer"}
        data-test-id='secondPaymentMethods'
      >
        <div className={"payWithOther payWithOtherTitle"}>
          {configJSON.label_selectSecondPaymentMethod}
        </div>
        {/* {secondPaymentMethods
          .filter((item: IPaymentMethod) => {
            if (item.name === "Wallet") {
              return walletBalance + goldenpointApplicableBalance > 0;
            }
            return true;
          })
          .map((item: IPaymentMethod) => {
            const isSelected = selectedSecondPaymentMethod === item.name;
            let classNames = "otherPayment";
            if (!item.enableSecond)
              classNames += " " + "disableSecondPayMethod";
            return (
              <div
                key={item.name}
                className={classNames}
                onClick={() =>
                  item.enableSecond && this.onSelectSecondPayments(item.name)
                }
              >
                <Radio
                  checked={isSelected}
                  icon={<span style={webStyle.icon} />}
                  checkedIcon={<span style={webStyle.checkedIcon} />}
                />
                <div className={"payMethodTitle"}>{item.name}</div>
              </div>
            );
          })} */}
        {secondPaymentMethods
          .filter((item: IPaymentMethod) => {
            // if (item.name === "Wallet") {
            //   return walletBalance + goldenpointApplicableBalance > 0;
            // }
            if (item.name === "Wallet") {
              const wallet = Number(walletBalance) || 0;
              const gp = Number(goldenpointApplicableBalance) || 0;
              return wallet + gp > 0;
            }
            return true;
          })
          .map((item: IPaymentMethod) => {
            const isSelected = selectedSecondPaymentMethod === item.name;
            let classNames = "otherPayment";
            if (!item.enableSecond) classNames += " disableSecondPayMethod";
            return (
              <div key={item.name}>
                <div
                  className={classNames}
                  onClick={() =>
                    item.enableSecond && this.onSelectSecondPayments(item.name,item)
                  }
                >
                  <Radio
                    checked={isSelected}
                    icon={<span style={webStyle.icon} />}
                    checkedIcon={<span style={webStyle.checkedIcon} />}
                  />
                  <div className='payMethodTitle'>{item.name}</div>
                </div>
                {item.name === "Wallet" && isSelected && (
                  <div style={{ marginLeft: 30 }}>
                    <div style={cardStyle}>
                      <label style={labelStyle}>
                        <input
                          type='radio'
                          name='paymentSource'
                          disabled={walletBalance <= 0}
                          checked={this.state.paymentSource === "wallet"}
                          onChange={() => {
                            this.setState({ paymentSource: "wallet" });
                            this.handleSecondPaymentToggle(
                              Number(walletBalance)
                            );
                          }}
                        />
                        <b>Wallet Balance:</b> {currency} {walletBalance}
                      </label>
                    </div>
                    {/* <div style={cardStyle}>
                      <div style={rowBetween}> */}
                        {/* <label style={labelStyle}>
                          <input
                            type='checkbox'
                            name='paymentSource'
                            disabled={goldenpointApplicableBalance <= 0}
                            checked={this.state.shouldUseGoldenPoints}
                            onChange={(e) => {
                              e.stopPropagation();
                              if (
                                Number(order?.applied_discount) > 0 && bonusPoints > 0 &&
                                !this.state.is_golden_bonus_used
                              ) {
                                this.setState({
                                  errorMessage:
                                    "Discount already applied. Cannot select Golden Points.",
                                  errorSnackbarOpen: true,
                                });
                                return;
                              }
                              this.setState({
                                shouldUseGoldenPoints: isChecked,
                                paymentSource: isChecked ? "golden" : null,
                              });
                              this.handleSecondPaymentToggle(
                                isChecked
                                  ? Number(goldenpointApplicableBalance)
                                  : 0
                              );
                              if (bonusPoints > 0){
                              this.applyGoldenPoints(true)
                              }
                            }}
                          />
                          <b>Golden Points:</b> {goldenpointApplicableBalance}
                        </label> */}
                        {/* <span
                          style={{ cursor: "pointer" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.setState((prev) => ({
                              showGoldenDetails: !prev.showGoldenDetails,
                            }));
                          }}
                        >
                          {this.state.showGoldenDetails ? "▲" : "▼"}
                        </span>
                      </div> */}
                      {/* {this.state.showGoldenDetails && (
                        <div style={detailsContainer}>
                          {goldenPointList.map((gp, index) => (
                            <div key={index} style={{ fontWeight: 500 }}>
                              <div>
                                <b>Name:</b> {gp?.name}
                              </div>
                              <div>
                                <b>Base Points:</b> {gp?.base_points}
                              </div>
                              <div>
                                <b>Bonus Points:</b> {gp?.bonus_points}
                              </div>
                              <div>
                                <b>Total Points:</b> {gp?.total_points}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div> */}
                  </div>
                )}
              </div>
            );
          })}

        <div className={"payWithOther payWithamountPayableString"}>
          {amountPayableString}
        </div>
      </div>
    );
  }

  renderAfterUse() {
    const {
      currency,
      secondPaymentEnabled,
      walletBalance,
      goldenpointBalance,
      goldenpointApplicableBalance,
      remainBalance,
      showGoldenDetails,
      // useGoldenPoints,
      expiredGoldenPoints,
      compensationCreditBalance,
      activeTab,
      order,
      bonusPoints,
      free_wash_amount,
      free_wash_quantity
    } = this.state;
    const remainNum = parseFloat(remainBalance as any);
    const usableGP = goldenpointBalance - expiredGoldenPoints;

    const { goldenPointList = [] } = this.props;
    const showGoldenPointsSection = goldenpointBalance > 0 && usableGP > 0;

    const showWalletDeduction =
      goldenpointApplicableBalance > 0 &&
      !isNaN(remainNum) &&
      typeof goldenpointApplicableBalance === "number" &&
      typeof walletBalance === "number" &&
      ((walletBalance > 0 && remainNum > goldenpointApplicableBalance) ||
        (walletBalance === 0 &&
          usableGP > 0 &&
          remainNum > goldenpointApplicableBalance));
    const showReceivedAmount =
      (walletBalance > 0 && remainNum <= walletBalance) ||
      (walletBalance === 0 && usableGP > 0 && remainNum > 0);

      return (
        <div>
          {showReceivedAmount && (
            <div className='receivedAmountContainer'>
              <div>
                <img src={label} />
              </div>
              <div>
                {`You are using received amount ${currency} ${
                  secondPaymentEnabled ? walletBalance : remainBalance
                }`}
              </div>
            </div>
          )}
        {/* {walletBalance > 0 && ( */}
          <div
            style={{
              marginTop: "10px",
              border: "1px solid #ccc",
              borderRadius: 8,
              background: "#fff",
              padding: 12,
              cursor: "pointer",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  cursor: "pointer",
                }}
              >
                <input
                  type='radio'
                  name='paymentSource'
                  disabled={walletBalance === 0}
                  checked={this.state.paymentSource === "wallet"}
                  onClick={() => {
                    this.togglePaymentSource("wallet");
                    this.handleSecondPaymentToggle(Number(walletBalance));
                  }}
                />
                <b>Wallet Balance:</b> {currency} {walletBalance}
              </label>
            </div>
          </div>

          {!this.state.edit_order && (
            <div
              style={{
                marginTop: "10px",
                border: "1px solid #ccc",
                borderRadius: 8,
                background: "#fff",
                padding: 12,
                cursor: "pointer",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <input
                    type='radio'
                    name='paymentSource'
                    style={{ marginRight: "8px" }}
                    disabled={goldenpointApplicableBalance <= 0 && free_wash_amount <=0 }
                    // checked={
                    //   (goldenpointApplicableBalance > 0 || free_wash_amount > 0) &&
                    //   this.state.shouldUseGoldenPoints
                    // }
                    checked={
                      this.state.errorMessage !== "Not enough Golden Points" &&
                      (goldenpointApplicableBalance > 0 || free_wash_amount > 0) &&
                      this.state.shouldUseGoldenPoints
                    }
                    onClick={(e) => {
                      e.stopPropagation();

                      const subtotal =
                        Number(this.state.applicable_sub_total || 0) -
                        (Number(this.state.free_wash_discount || 0) > 0
                          ? Number(this.state.free_wash_discount || 0)
                          : Number(this.state.appliedDiscount || 0));
                      const gpBalance = Number(goldenpointApplicableBalance || 0) 
                      const gp = Number(gpBalance || 0);
                      const freeWash = Number(free_wash_amount || 0);
                      const total = Number(subtotal || 0);
                      if ((gp + freeWash) < total) {
                        this.setState({
                          errorMessage: "Not enough Golden Points",
                          errorSnackbarOpen: true,
                        });
                        return;
                      }
                      // if (
                      //   Number(order?.applied_discount) > 0 &&
                      //   bonusPoints > 0 &&
                      //   !this.state.is_golden_bonus_used
                      // ) {
                      //   this.setState({
                      //     errorMessage:
                      //       "Discount already applied. Cannot select Golden Points.",
                      //     errorSnackbarOpen: true,
                      //   });
                      //   return;
                      // }

                      if (goldenpointApplicableBalance <= 0 && free_wash_amount <= 0) return;

                      this.setState({ paymentSource: "golden" });
                      this.toggleGoldenPoints();
                      this.handleSecondPaymentToggle(
                        Number(goldenpointApplicableBalance)
                      );
                    }}
                  />
                  <b>Golden Points:  </b> {goldenpointApplicableBalance}
                </div>

                <span
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.setState((prevState) => ({
                      showGoldenDetails: !prevState.showGoldenDetails,
                    }));
                  }}
                >
                  {showGoldenDetails ? "▲" : "▼"}
                </span>
              </div>

              {showGoldenDetails && (
                <div
                  style={{
                    marginTop: 10,
                    display: "flex",
                    flexDirection: "column",
                    gap: 6,
                  }}
                >
                  {goldenPointList.map((item, index) => (
                    <div
                      key={index}
                      style={{ position: "relative", fontWeight: 500 }}
                    >
                      <span className='gp-name'>{item?.name}</span>
                      <div className='gp-tooltip'>
                        <div>
                          <b>Base Points:</b> {item?.base_points}
                        </div>
                        <div>
                          <b>Bonus Points:</b> {item?.bonus_points}
                        </div>
                        <div>
                          <b>Total Points:</b> {item?.total_points}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            )}

      {secondPaymentEnabled && this.renderSecondPayments()}
    </div>
  );
  }

  renderRedeem() {
    const { isRedeemAllPoints, isUsed } = this.state;
    if (!isRedeemAllPoints) return this.renderUsablePoints();
    else if (!isUsed) return this.renderAfterRedeem();
    else return this.renderAfterUse();
  }

  isPayButtonEnabled(withWallet?: boolean) {
    const {
      walletBalance,
      points,
      skipRedeemPoints,
      goldenpointBalance,
      goldenpointApplicableBalance,
      expiredGoldenPoints,
      free_wash_amount
    } = this.state;
    if (!lodash.isFinite(Number(this.state.customPaymentAmount))) {
      return false;
    }
    if (withWallet && !walletBalance && !goldenpointBalance)
    //   return points > 0 ? !skipRedeemPoints : false;
    return points > 0 ? !skipRedeemPoints : free_wash_amount > 0 ? true   : false;
    return true;
  }

  renderRedeemOrSecondPayment(withWallet: boolean) {
    const {
      remainBalance,
      walletBalance,
      skipRedeemPoints,
      customPaymentAmount,
      goldenpointApplicableBalance,
      free_wash_amount
    } = this.state;

    const wallet = Number(walletBalance) || 0;
    const golden = Number(goldenpointApplicableBalance) || 0;
    const customAmount = Number(customPaymentAmount) || 0;

    const hasAnyBalance = wallet > 0 || golden > 0 || free_wash_amount > 0;
    if (withWallet && !skipRedeemPoints) {
      return hasAnyBalance && this.renderAfterUse();
    }
    if (customAmount < remainBalance) {
      return this.renderSecondPayments();
    }

    return null;
  }

  renderBothRedeemAndSecondPayment() {
    const {
      walletBalance,
      customPaymentAmount,
      remainBalance,
      isUsed,
      goldenpointBalance,
      goldenpointApplicableBalance,
    } = this.state;

    const wallet = Number(walletBalance) || 0;
    const golden = Number(goldenpointBalance) || 0;
    const customAmount = Number(customPaymentAmount) || 0;
    const remain = Number(remainBalance) || 0;
    const isBothInsufficient = wallet < customAmount && golden < customAmount;

    return (
      <>
        {this.renderRedeem()}
        {isBothInsufficient &&
          customAmount < remain &&
          !isUsed &&
          this.renderSecondPayments()}
      </>
    );
  }

  renderAmountToPay(withWallet: boolean) {
    const {
      points,
      activeTab,
      remainBalance,
      walletBalance,
      goldenpointBalance,
      goldenpointApplicableBalance,
      expiredGoldenPoints,
      skipRedeemPoints,
      customPaymentAmount,
      compensationCreditBalance,
    } = this.state;

    const remainNum = parseFloat(remainBalance as any);
    const usableGP = Number(goldenpointApplicableBalance);
    const isGoldenPointSelected = this.state.shouldUseGoldenPoints === true;

    return (
      (withWallet
        ? walletBalance > 0 ||
          compensationCreditBalance > 0 ||
          usableGP > 0 ||
          (points > 0 && !skipRedeemPoints)
        : true) && (
        <div>
          <div className={"amountToPayTitle"}>Amount to Pay</div>
          <div className={"totalTextContainer"}>
            {renderBaseOnConditions(
              this.state.isRemainingBalanceLoading,
              <CircularProgress />,
              <Box display={"flex"} flexDirection={"column"}>
                <Input
                  data-test-id='input-amount'
                  type='text'
                  value={customPaymentAmount}
                  inputProps={{
                    readOnly: isGoldenPointSelected
                  }}
                  placeholder='Amount to pay'
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    const valueStr = event.target.value;
                    if (!/^\d*\.?\d*$/.test(valueStr)) return;
                    const valueNum = parseFloat(valueStr);
                    this.onChangeAmountToPay(
                      activeTab,
                      valueStr,
                      walletBalance,
                      goldenpointBalance,
                      goldenpointApplicableBalance,
                      expiredGoldenPoints,
                      remainBalance
                    );
                  }}
                  onKeyPress={(event) =>
                    this.onKeyPressInput(
                      event.key,
                      event.preventDefault,
                      Boolean(event.isDefaultPrevented)
                    )
                  }
                  className={
                    this.state.remainBalance > Number(customPaymentAmount)
                      ? "amountTextContainerWithPayAll"
                      : "amountTextContainer"
                  }
                  startAdornment={
                    <div
                      style={{ marginRight: "12px" }}
                      className={"amountTextContainerSar"}
                    >
                      SAR
                    </div>
                  }
                  disableUnderline={true}
                />
                {!lodash.isFinite(Number(customPaymentAmount)) && (
                  <span className='errorMsgAmount'>
                    Please enter a valid number.
                  </span>
                )}
              </Box>
            )}

            {
              // (walletBalance > 0 || usableGP > 0) &&
              this.state.remainBalance > Number(customPaymentAmount) && (
                <div
                  className={"payAllButton"}
                  data-test-id='payAll'
                  onClick={this.handlePayAll}
                >
                  {configJSON.label_payAll}
                </div>
              )
            }
          </div>
        </div>
      )
    );
  }

  renderLateDeliverySection() {
    const { lateDeliveryConfigs, selectedLateDeliveryConfig } = this.state;

    if (lateDeliveryConfigs.length === 0) return null;

    return (
      <div className={"lateDeliverySectionContainer"}>
        <div className={"lateDeliveryHeader"}>
          <AccessTimeIcon className={"lateDeliveryClockIcon"} />
          Late Delivery
        </div>
        <div className={"lateDeliveryOptionsContainer"}>
          {lateDeliveryConfigs.map((config) => (
            <div
              key={config.id}
              className={"lateDeliveryOptionItem"}
              onClick={() => this.handleLateDeliverySelection(config.id)}
            >
              <input
                type='checkbox'
                className={"lateDeliveryOptionCheckbox"}
                checked={selectedLateDeliveryConfig === config.id}
                onChange={() => this.handleLateDeliverySelection(config.id)}
                style={{
                  accentColor: config.attributes.color,
                }}
              />
              <label className={"lateDeliveryOptionLabel"}>
                {config.attributes.name} ({config.attributes.hours}h)
              </label>
              <div
                className={"lateDeliveryColorIndicator"}
                style={{
                  backgroundColor: config.attributes.color + "20",
                  border: `1px solid ${config.attributes.color}`,
                }}
              />
            </div>
          ))}
        </div>
      </div>
    );
  }

  renderCash(withWallet: boolean) {
    const {
      skipRedeemPoints,
      points,
      walletBalance,
      goldenpointBalance,
      loading,
      isRemainingBalanceLoading,
      expiredGoldenPoints,
      isPayButtonClicked,
      remainBalance,
      useGoldenPoints,
      goldenpointApplicableBalance,
      compensationCreditBalance,
      free_wash_amount
    } = this.state;
    const remainNum = Number(remainBalance);
    const usableGP = Number(goldenpointApplicableBalance);

    const isDisable = !this.isPayButtonEnabled(withWallet);

    let isPayButtonDisabledByBalance = false;
    let notSufficientBalance = false;
    let showExpiredGPMessage = false;
    let allowSecondPayment = true;
    if (withWallet) {
      if (withWallet) {
          if (Number(free_wash_amount) > 0) {
            isPayButtonDisabledByBalance = false;
          } else {
          isPayButtonDisabledByBalance =
            (Number(walletBalance) <= 0 &&
              Number(goldenpointApplicableBalance) <= 0) ||
            (Number(walletBalance) <= 0 && usableGP <= 0);
        }
      }

      notSufficientBalance =
        !loading && !isRemainingBalanceLoading && isPayButtonDisabledByBalance;
      showExpiredGPMessage =
        usableGP <= 0 &&
        (Number(walletBalance) <= 0 || expiredGoldenPoints > 0);
      // if (Number(walletBalance) <= 0 && usableGP <= 0) {
      //   return (
      //     <div
      //       style={{
      //         marginTop: 10,
      //         color: "#721c24",
      //         fontWeight: 600,
      //         display: "flex",
      //         alignItems: "flex-start",
      //         gap: "8px",
      //         // backgroundColor: "#f8d7da",
      //         padding: "12px",
      //         borderRadius: "8px",
      //         border: "1px solid #f5c6cb",
      //       }}
      //     >
      //       <span style={{ fontSize: "18px", lineHeight: "1.2" }}>⚠️</span>
      //       <span style={{ fontSize: "16px", lineHeight: "1.4" }}>
      //         You have no active wallet balance <br />
      //         or usable golden points. <br />
      //         They may be expired or not yet active.
      //       </span>
      //     </div>
      //   );
      // }
      if (usableGP > remainNum) {
        allowSecondPayment = false;
      }

      // if (useGoldenPoints) {
      allowSecondPayment = usableGP < remainNum;
      // }

      if (!useGoldenPoints) {
        const walletNum = Number(walletBalance);
        if (walletNum > 0) {
          allowSecondPayment = walletNum < remainNum;
        } else {
          allowSecondPayment = true;
        }
      }
    }
    let classNames = "payBtn";
    if (
      isDisable ||
      loading ||
      isRemainingBalanceLoading ||
      isPayButtonClicked ||
      (withWallet && isPayButtonDisabledByBalance)
    ) {
      classNames += " disablePayButton";
    }
    return (
      <div className='amountToPayContainer'>
        {this.renderAmountToPay(withWallet)}
        {this.renderRedeemOrSecondPayment(withWallet)}

        {withWallet && notSufficientBalance && free_wash_amount <= 0 &&(
          <div className='notSufficientBalanceLabel'>
            {configJSON.label_notSufficientBalanceLabel}
          </div>
        )}
        {/* 
        {withWallet && showExpiredGPMessage && (
          <div
            style={{
              marginTop: 10,
              padding: "12px",
              borderRadius: "8px",
              border: "1px solid #f5c6cb",
              backgroundColor: "#f8d7da",
              color: "#721c24",
              fontWeight: 600,
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <span style={{ fontSize: "16px" }}>⚠️</span>
            <span>Your golden points are expired or not yet active.</span>
          </div>
        )} */}

        <div
          className={classNames}
          data-test-id='btn-cash-payment'
          onClick={() =>
            !isPayButtonClicked &&
            !isRemainingBalanceLoading &&
            !isDisable &&
            !loading &&
            !(withWallet && isPayButtonDisabledByBalance) &&
            this.handlePay()
          }
        >
          {!loading && !isPayButtonClicked ? (
            configJSON.label_pay
          ) : (
            <CircularProgress
              style={{ width: 16, height: 16, color: "#204B9C" }}
            />
          )}
        </div>
      </div>
    );
  }

  renderPayLater() {
    const isDisable = !this.isPayButtonEnabled();

    let classNames = "payBtn" + " ";
    classNames += isDisable ? "disablePayButton" : "";
    classNames += this.state.loading ? " disablePayButton" : "";
    classNames += this.state.isRemainingBalanceLoading
      ? " disablePayButton"
      : "";
    classNames += this.state.isPayButtonClicked ? " disablePayButton" : "";

    return (
      <div className={"amountToPayContainer"}>
        <div
          className={classNames}
          data-test-id='btn-pay-later'
          onClick={() =>
            !this.state.isPayButtonClicked &&
            !this.state.isRemainingBalanceLoading &&
            !isDisable &&
            !this.state.loading &&
            this.handlePay()
          }
        >
          {!this.state.loading && !this.state.isPayButtonClicked ? (
            configJSON.label_pay
          ) : (
            <CircularProgress
              style={{ width: 16, height: 16, color: "#204B9C" }}
            />
          )}
        </div>
      </div>
    );
  }

  renderSideBar() {
    const { fromUnpaid, order, isMainPayment } = this.props || {};
    const {
      activeTab,
      paymentMethods,
      currency,
      walletBalance,
      goldenpointBalance,
    } = this.state || {};

    const isQuickDrop = Boolean(order?.is_quick_drop);

    const tabs =
      paymentMethods?.filter((paymentMethod) => {
        const condition1 = ["Payment Link", "Pay Later"].includes(
          paymentMethod.name
        );
        const condition2 =
          Boolean(fromUnpaid) && !isMainPayment
            ? paymentMethod.name != "Pay Later"
            : true;
        return isQuickDrop ? condition1 : condition2;
      }) || [];

    return (
      <div className={"sideBarContainer"}>
        {tabs.map((item) => {
          const { name, id } = item;
          const paymentMethod = this.state.paymentMathod?.trim();
          const icon = item.attributes?.icon?.data?.attributes?.image;
          const isActive = name === paymentMethod;

          const walletString = `(${getCurrencyString(
            currency,
            walletBalance
          )})`;
          const goldenPointString = `(${getCurrencyString(
            "pts",
            goldenpointBalance
          )})`;
          // Show BOTH only when Wallet tab
          const displayString = name === "Wallet" ? "" : "";

          let classNames = "sideBarItemContainer ";
          if (isActive) classNames += "activeSideBarItem";

          return (
            <div
              className={classNames}
              key={"sidebar-payment-tabs-item" + name}
              data-test-id={"payment-section-" + name}
              onClick={() => this.onChangeTab(id, name)}
            >
              <img className={"sideBarIconContainer"} src={icon} />
              <div className={"sideBarItemText"}>
                {`${name} ${displayString}`}
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  displayRemainingPayableAmountForUnpaidOrer = (
    order: IOrder | undefined,
    remainBalance: number
  ) => {
    return order ? `SAR ${remainBalance}` : "";
  };

  renderBasedOnPaymentMethod = (activeTabTitle: string) => {
    if (activeTabTitle === "Wallet") {
      return this.renderCash(true);
    } else {
      return this.renderCash(false);
    }
  };

  renderWalletVerificationModal() {
    const {
      walletVerifyOpen,
      walletVerifyChannel,
      walletVerifyOtpCode,
      walletVerifyToken,
      walletVerifyMaskedPhone,
      walletVerifyOtpSent,
      walletVerifySending,
      walletVerifyVerifying,
      walletVerifyError,
      walletVerifyWalletType,
      walletVerifyAmount,
      currency,
    } = this.state;

    if (!walletVerifyOpen) return null;

    const walletTypeLabel =
      walletVerifyWalletType === "golden_point"
        ? "Golden Points"
        : walletVerifyWalletType === "compensation"
        ? "Compensation"
        : walletVerifyWalletType === "loyalty"
        ? "Loyalty"
        : "Wallet";

    const verifyDisabled =
      walletVerifyVerifying ||
      (walletVerifyChannel === "qr" && !walletVerifyToken.trim()) ||
      (walletVerifyChannel === "otp" &&
        (!walletVerifyOtpSent || walletVerifyOtpCode.length !== 4));

    return (
      <Dialog
        open={walletVerifyOpen}
        maxWidth='xs'
        fullWidth
        PaperProps={{ style: { borderRadius: 12 } }}
      >
        <Box style={verifyModalStyles.container}>
          <div style={verifyModalStyles.title}>Verify Customer</div>
          <div style={verifyModalStyles.subtitle}>
            {`${walletTypeLabel} payment of ${currency} ${walletVerifyAmount.toFixed(
              2
            )}`}
          </div>

          {!walletVerifyChannel && (
            <div style={verifyModalStyles.choiceContainer}>
              <div
                data-test-id='wallet-verify-qr'
                style={verifyModalStyles.choiceBtn}
                onClick={() => this.selectWalletVerifyChannel("qr")}
              >
                Scan QR
              </div>
              <div
                data-test-id='wallet-verify-otp'
                style={verifyModalStyles.choiceBtn}
                onClick={() => {
                  this.selectWalletVerifyChannel("otp");
                  this.sendWalletVerifyOtp();
                }}
              >
                Send OTP
              </div>
            </div>
          )}

          {walletVerifyChannel === "qr" && (
            <div style={verifyModalStyles.section}>
              <div style={verifyModalStyles.label}>
                Paste the customer's QR token
              </div>
              <Input
                data-test-id='wallet-verify-qr-input'
                fullWidth
                disableUnderline
                value={walletVerifyToken}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  this.setWalletVerifyToken(e.target.value)
                }
                placeholder='QR token'
                style={verifyModalStyles.input}
              />
            </div>
          )}

          {walletVerifyChannel === "otp" && (
            <div style={verifyModalStyles.section}>
              {walletVerifySending && (
                <div style={verifyModalStyles.helper}>Sending OTP…</div>
              )}
              {walletVerifyOtpSent && (
                <>
                  <div style={verifyModalStyles.helper}>
                    {`OTP sent to ${walletVerifyMaskedPhone}. Ask the customer to read the 4-digit code.`}
                  </div>
                  <Input
                    data-test-id='wallet-verify-otp-input'
                    fullWidth
                    disableUnderline
                    value={walletVerifyOtpCode}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      this.setWalletVerifyOtpCode(e.target.value)
                    }
                    placeholder='Enter 4-digit OTP'
                    style={verifyModalStyles.input}
                    inputProps={{ maxLength: 4 }}
                  />
                  <div
                    data-test-id='wallet-verify-resend'
                    style={verifyModalStyles.linkBtn}
                    onClick={() =>
                      !walletVerifySending && this.sendWalletVerifyOtp()
                    }
                  >
                    Resend OTP
                  </div>
                </>
              )}
            </div>
          )}

          {walletVerifyError && (
            <div style={verifyModalStyles.error}>{walletVerifyError}</div>
          )}

          <div style={verifyModalStyles.actions}>
            <div
              data-test-id='wallet-verify-cancel'
              style={verifyModalStyles.cancelBtn}
              onClick={this.closeWalletVerification}
            >
              Cancel
            </div>
            {walletVerifyChannel && (
              <div
                data-test-id='wallet-verify-submit'
                style={{
                  ...verifyModalStyles.confirmBtn,
                  ...(verifyDisabled ? verifyModalStyles.confirmBtnDisabled : {}),
                }}
                onClick={() => !verifyDisabled && this.verifyWallet()}
              >
                {walletVerifyVerifying ? (
                  <CircularProgress
                    style={{ width: 16, height: 16, color: "#FFF" }}
                  />
                ) : (
                  "Verify"
                )}
              </div>
            )}
          </div>
        </Box>
      </Dialog>
    );
  }

  renderPaymentReferenceModal() {
    const { paymentReferenceModalOpen, paymentReferenceNumber } = this.state;
    if (!paymentReferenceModalOpen) return null;

    return (
      <Dialog
        open={paymentReferenceModalOpen}
        maxWidth='xs'
        fullWidth
        PaperProps={{ style: { borderRadius: 12 } }}
      >
        <Box style={verifyModalStyles.container}>
          <div style={verifyModalStyles.title}>Payment Reference</div>
          <div style={verifyModalStyles.subtitle}>
            Enter the reference number from the credit card transaction.
          </div>
          <div style={verifyModalStyles.section}>
            <div style={verifyModalStyles.label}>Reference Number</div>
            <Input
              data-test-id='payment-reference-input'
              fullWidth
              disableUnderline
              value={paymentReferenceNumber}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                this.setPaymentReferenceNumber(e.target.value)
              }
              placeholder='Enter reference number'
              style={verifyModalStyles.input}
            />
          </div>
          <div style={verifyModalStyles.actions}>
            <div
              data-test-id='payment-reference-cancel'
              style={verifyModalStyles.cancelBtn}
              onClick={this.closePaymentReferenceModal}
            >
              Cancel
            </div>
            <div
              data-test-id='payment-reference-submit'
              style={{
                ...verifyModalStyles.confirmBtn,
                ...(paymentReferenceNumber.trim()
                  ? {}
                  : verifyModalStyles.confirmBtnDisabled),
              }}
              onClick={() =>
                paymentReferenceNumber.trim() && this.submitPaymentReference()
              }
            >
              Confirm
            </div>
          </div>
        </Box>
      </Dialog>
    );
  }
  // Customizable Area End

  render() {
    // Customizable Area Start
    const { open, totalItems, taxPercentage, paymentClicked } =
      this.props || {};

    const {
      currency,
      errorMessage,
      remainBalance,
      successMessage,
      errorSnackbarOpen,
      paymentMethods,
      order,
      free_wash_discount
    } = this.state || {};
    const activeTabItem = paymentMethods?.find(
      (item) => item.id === this.state.activeTab
    );
    const activeTabTitle = activeTabItem ? activeTabItem.name : "";
    const appliedDiscount = Number(order?.applied_discount || 0);
    const freeWashDiscount = Number(order?.discount_summary?.free_wash_discount || 0);
    const isStoreDiscount = order?.discount_summary?.is_store_discount;
    const discountValue = appliedDiscount > 0 ? appliedDiscount : freeWashDiscount;
    const isGoldenPointSelected = this.state.shouldUseGoldenPoints === true;
    const discountLabel =
    //  order?.discount_summary?.is_golden_bonus_used ? configJSON.label_goldenPointDiscountDiscount :
      Number(free_wash_discount) > 0 ? configJSON.label_freeWashDiscount :
      order?.discount_summary?.has_promotion ? "Promotional Discount" : 
      order?.discount_summary?.has_coupon ? configJSON.label_promoCodeDiscount :
      order?.discount_summary?.is_store_discount ? configJSON.label_storeDiscount :
      freeWashDiscount > 0 ? configJSON.label_freeWashDiscount : "";

    const hasDiscount =
      discountValue > 0 &&
      (
        order?.discount_summary?.has_promotion ||
        order?.discount_summary?.has_coupon ||
        // order?.discount_summary?.is_golden_bonus_used ||
        order?.discount_summary?.is_store_discount ||
        freeWashDiscount > 0
      );
    const discount = appliedDiscount > 0 ? appliedDiscount : freeWashDiscount;
    // Customizable Area End
    return (
      // Customizable Area Start
      <Dialog
        maxWidth='xl'
        open={open}
        data-test-id='paymentModal'
        PaperProps={{
          style: {
            borderRadius: 12,
          },
        }}
      >
        <StyledWrapper>
          <div
            className={"paymentModalMainContainer"}
            data-test-id={configJSON.paymentModalTest}
          >
            <div className={"headerContainer"}>
              {configJSON.label_paymentMethod}
            </div>
            <div className={"mainContentContainer"}>
              <div className={"detailSectionContainer"}>
                {paymentMethods.length === 0 && (
                  <div className={"noPaymentMethod"}>No payment found</div>
                )}
                {paymentMethods.length > 0 && (
                  <>
                    <div className={"detailSectionInnerContainer"}>
                      {this.renderSideBar()}
                      {this.state.showOtpScreen ? (
                        <OtpPage
                          onSuccess={this.onOtpSuccess}
                          show={this.state.showOtpScreen}
                          customer_id={this.props.customerId}
                          totalAmount={this.state.remainBalance + ""}
                          onError={this.handleOtpError}
                          otpAttemptRights={this.state.otpAttemptRights} 
                          isButtonDisabled={this.state.isButtonDisabled} 
                          verifyOtp={this.makePayment}
                           order={this.props.order}
                        />
                      ) : (
                        <>{this.renderBasedOnPaymentMethod(activeTabTitle)}</>
                      )}
                    </div>
                    {this.renderLateDeliverySection()}
                  </>
                )}
              </div>
              <div className={"billingPartMainContainer"}>
                <div className={"billingSectionContainer"}>
                  <PromoCodePayment
                    order={this.props.order}
                    onApply={this.props.onPromoCodeApply}
                    cleaningOrder={this.props.cleaningOrder}
                    applyGoldenPoints={this.applyGoldenPoints}
                    otpScreen={this.state.showOtpScreen}
                    freeWashDiscount={this.state.free_wash_discount}
                  />
                </div>
                <div className={"billingSectionContainer"}>
                  <div className={"billingTitle"}>Billing</div>
                  <div className={"billingDetailItemContainer"}>
                    <div>{configJSON.label_totalItems}</div>
                    <div>{totalItems}</div>
                  </div>
                  <div className={"billingDetailItemContainer"}>
                    <div>{configJSON.label_subtotal}</div>
                    {/* <div>{order && `SAR ${order?.sub_total}`}</div> */}
                      {`SAR ${
                      !order?.sub_total || Number(order?.sub_total) === 0
                        ? this.state.originalOrder?.sub_total
                        : order?.sub_total
                    }`}
                    </div>
                {/* {hasDiscount && !this.state.shouldUseGoldenPoints &&  freeWashDiscount (
                  <div className="billingDetailItemContainer">
                    <div>{discountLabel}</div>
                    <div data-test-id="applied-discount">
                      {`- ${getCurrencyString(currency, discountValue)}`}
                    </div>
                  </div>
                )} */}
                {(Number(freeWashDiscount || 0) > 0 ||
                  (hasDiscount && !this.state.shouldUseGoldenPoints)) && (
                  <div className="billingDetailItemContainer">
                    <div>{discountLabel}</div>
                    <div data-test-id="applied-discount">
                      {`- ${getCurrencyString(currency, discountValue)}`}
                    </div>
                  </div>
                )}

                  {order?.service_charge && (
                    <div className={"billingDetailItemContainer"}>
                      <div>{configJSON.label_service_charge}</div>
                      <div>{order ? `SAR ${order?.service_charge}` : ""}</div>
                    </div>
                  )}
                  {order && !isGoldenPointSelected &&
                    Number(remainBalance) > 0 &&
                    (freeWashDiscount > 0 ||
                      Number(order?.applied_discount || 0) > 0 ) && (
                      <div className={"billingDetailItemContainer"}>
                        <div>{configJSON.taxable_amount}</div>
                        {/* <div>{configJSON.base_point}</div> */}
                        <div>
                          {order?.discount_summary?.is_golden_bonus_used
                            ? `SAR ${this.state.order?.taxable_amount}`
                            : `SAR ${(Number(order?.sub_total || 0) - Number(discount || 0)).toFixed(2)}`}
                            {/* : `SAR ${(Number(order?.sub_total || 0)).toFixed(2)}`} */}
                        </div>
                      </div>
                    )}
                  {/* <div className={"billingDetailItemContainer"}>
                    <div>
                      {configJSON.label_tax} ({taxPercentage})
                    </div>
                    <div>
                    { `SAR ${
                        !order?.total_tax
                            ? this.state.originalOrder?.total_tax
                            : order?.total_tax
                        }`
                      }
                  </div> */}
                    {/* <div>{order ? `SAR ${order?.total_tax}` : ""}</div> */}
                  {/* </div> */}

                    {(Number(
                      !order?.total_tax
                        ? this.state.originalOrder?.total_tax
                        : order?.total_tax
                    ) > 0 ) && (
                    <div className={"billingDetailItemContainer"}>
                      <div>
                        {configJSON.label_tax} ({taxPercentage})
                      </div>
                      <div>
                        {`SAR ${
                          !order?.total_tax
                            ? this.state.originalOrder?.total_tax
                            : order?.total_tax
                        }`}
                      </div>
                    </div>
                  )}
                  <div className={"billingDetailSeperator"} />
                  <div className={"billingSubTotalContainer"}>
                    <div>{configJSON.label_total}</div>
                    <div>
                      {remainBalance ? `SAR ${remainBalance}` : "SAR 0.00"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              onClick={() => {
                if (!this.state.loading) {
                  this.applyGoldenPoints(false);
                  this.handleClose();
                }
              }}
              className={"modalFooterContainer"}
            >
              {configJSON.label_backToModify}
            </div>
          </div>
          <CustomSnackbar
            severity='error'
            open={errorSnackbarOpen}
            errorMessage={errorMessage}
            data-test-id='customErrorSnackbar'
            onClose={this.handleSnackbarClose}
          />
          {paymentClicked && (
            <CustomSnackbar
              open={!!successMessage}
              errorMessage={successMessage}
              data-test-id='successSnackBar'
              onClose={this.handleSuccessSnackbarClose}
              severity='success'
            />
          )}
          {this.renderWalletVerificationModal()}
          {this.renderPaymentReferenceModal()}
        </StyledWrapper>
      </Dialog>
      // Customizable Area End
    );
  }
}
// Customizable Area Start

const cardStyle = {
  marginTop: "10px",
  border: "1px solid #ddd",
  borderRadius: 10,
  background: "#fff",
  padding: 14,
  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
};

const labelStyle = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  cursor: "pointer",
};

const rowBetween = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const detailsContainer: React.CSSProperties = {
  marginTop: 10,
  display: "flex",
  flexDirection: "column",
  gap: 6,
  paddingLeft: 10,
};

const verifyModalStyles: { [key: string]: React.CSSProperties } = {
  container: {
    padding: 24,
    display: "flex",
    flexDirection: "column",
    gap: 12,
  },
  title: {
    fontFamily: "Montserrat",
    fontSize: 18,
    fontWeight: 600,
    color: "#1A1A1A",
  },
  subtitle: {
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeight: 500,
    color: "#4D4D4D",
  },
  choiceContainer: {
    display: "flex",
    gap: 12,
    marginTop: 8,
  },
  choiceBtn: {
    flex: 1,
    padding: "14px 16px",
    border: "1px solid #204B9C",
    borderRadius: 8,
    color: "#204B9C",
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeight: 600,
    textAlign: "center",
    cursor: "pointer",
    background: "#FFF",
  },
  section: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
    marginTop: 8,
  },
  label: {
    fontFamily: "Montserrat",
    fontSize: 13,
    fontWeight: 600,
    color: "#1A1A1A",
  },
  helper: {
    fontFamily: "Montserrat",
    fontSize: 12,
    fontWeight: 500,
    color: "#4D4D4D",
  },
  input: {
    border: "1px solid #ECECEC",
    borderRadius: 8,
    padding: "10px 12px",
    fontSize: 14,
    fontFamily: "Montserrat",
  },
  linkBtn: {
    fontFamily: "Montserrat",
    fontSize: 12,
    fontWeight: 600,
    color: "#204B9C",
    cursor: "pointer",
    width: "fit-content",
  },
  error: {
    fontFamily: "Montserrat",
    fontSize: 12,
    color: "#FF0000",
  },
  actions: {
    display: "flex",
    gap: 12,
    marginTop: 16,
  },
  cancelBtn: {
    flex: 1,
    padding: 12,
    borderRadius: 8,
    border: "1px solid #ECECEC",
    color: "#4D4D4D",
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeight: 600,
    textAlign: "center",
    cursor: "pointer",
  },
  confirmBtn: {
    flex: 1,
    padding: 12,
    borderRadius: 8,
    background: "#204B9C",
    color: "#FFF",
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeight: 700,
    textAlign: "center",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  confirmBtnDisabled: {
    background: "#ECECEC",
    color: "#9CA3AF",
    cursor: "not-allowed",
  },
};

const webStyle = {
  icon: {
    display: "inline-block",
    width: 20,
    height: 20,
    borderRadius: "50%",
    border: "1px solid #64748B",
    marginRight: "10px",
  },
  checkedIcon: {
    display: "inline-block",
    width: 20,
    height: 20,
    borderRadius: "50%",
    border: "6px solid #204B9C",
    color: "#204b9c",
    marginRight: "10px",
  },
};
const StyledWrapper = styled("div")({
  "& .errorMsgAmount": {
    fontFamily: "Montserrat",
    fontWeight: 400,
    fontSize: "12px",
    color: "#FF0000",
  },
  "& .lateDeliverySectionContainer": {
    marginTop: 16,
    padding: "16px 0",
    width: "100%",
  },
  "& .lateDeliveryHeader": {
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: 600,
    color: "#000",
    marginBottom: 12,
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  "& .lateDeliveryClockIcon": {
    fontSize: "20px !important",
    color: "#204B9C",
  },
  "& .lateDeliveryOptionsContainer": {
    display: "flex",
    flexDirection: "row",
    gap: 12,
    flexWrap: "wrap",
  },
  "& .lateDeliveryOptionItem": {
    display: "flex",
    alignItems: "center",
    gap: 8,
    padding: "8px 12px",
    borderRadius: 8,
    border: "1px solid #ECECEC",
    cursor: "pointer",
    transition: "all 0.2s ease",
    flex: "0 0 auto",
    minWidth: "fit-content",
    "&:hover": {
      backgroundColor: "#F8F9FA",
    },
  },
  "& .lateDeliveryOptionCheckbox": {
    width: 18,
    height: 18,
    cursor: "pointer",
  },
  "& .lateDeliveryOptionLabel": {
    fontFamily: "Montserrat",
    fontSize: 14,
    fontWeight: 500,
    color: "#1A1A1A",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
  "& .lateDeliveryColorIndicator": {
    width: 24,
    height: 24,
    borderRadius: 4,
    flexShrink: 0,
  },
  "& .paymentModalMainContainer": {
    padding: 32,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  "& .headerContainer": {
    color: "#1A1A1A",
    fontSize: 24,
    fontFamily: "Montserrat",
    fontWeight: 600,
    marginBottom: 32,
  },
  "& .mainContentContainer": {
    display: "flex",
    flex: 1,
  },
  "& .modalFooterContainer": {
    color: "#4D4D4D",
    fontSize: 16,
    fontFamily: "Montserrat",
    fontWeight: 600,
    marginTop: 32,
    cursor: "pointer",
  },
  "& .detailSectionContainer": {
    width: 703,
    marginRight: 24,
    borderRadius: 12,
    background: "#FFF",
    boxShadow:
      "0px 8px 32px 0px rgba(0, 0, 0, 0.06), 0px 4px 8px 0px rgba(0, 0, 0, 0.03)",
    padding: 24,
  },
  "& .noPaymentMethod": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  },
  "& .billingPartMainContainer": {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  "& .billingSectionContainer": {
    padding: 24,
    background: "#FFF",
    borderRadius: 12,
    width: "100%",
    boxShadow:
      "0px 8px 32px 0px rgba(0, 0, 0, 0.06), 0px 4px 8px 0px rgba(0, 0, 0, 0.03)",
  },
  "& .detailSectionInnerContainer": {
    display: "flex",
    borderRadius: 12,
    border: "1px solid #ECECEC",
    background: "#FFF",
  },
  "& .sideBarContainer": {
    width: 294,
    borderRight: "1px solid #ECECEC",
  },
  "& .sideBarItemContainer": {
    padding: 24,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    color: "#000",
    "&:not(:last-child)": {
      borderBottom: "1px solid #ECECEC",
    },
  },
  "& .activeSideBarItem": {
    backgroundColor: "rgba(32, 75, 156, 0.1)",
    color: "#204B9C",
    borderTopLeftRadius: 8,
  },
  "& .sideBarIconContainer": {
    marginRight: 20,
    height: 24,
    width: 24,
  },
  "& .sideBarItemText": {
    fontSize: 14,
    fontFamily: "Montserrat",
    fontWeight: 500,
  },
  "& .amountToPayContainer": {
    width: 361,
    padding: 32,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  "& .amountToPayTitle": {
    color: "#000",
    fontSize: 16,
    fontFamily: "Montserrat",
    fontWeight: 600,
    marginBottom: 12,
  },
  "& .payAllButton": {
    background: "#F1F5F9",
    color: "#204B9C",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: 600,
    padding: "10px",
    width: "119px",
    height: "48px",
    textAlign: "center",
    paddingTop: "14px",
    borderRadius: "8px",
    cursor: "pointer",
  },
  "& .payBtn": {
    display: "flex",
    padding: 16,
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    color: "#FFF",
    fontSize: 16,
    fontFamily: "Montserrat",
    fontWeight: 700,
    cursor: "pointer",
    borderRadius: 8,
    background: "#204B9C",
    marginTop: 32,
  },
  "& .redeemBtn": {
    display: "flex",
    padding: 16,
    justifyContent: "center",
    alignItems: "center",
    color: "#204B9C",
    fontSize: 16,
    fontFamily: "Montserrat",
    fontWeight: 600,
    cursor: "pointer",
    borderRadius: 8,
    background: "#FFF",
  },
  "& .billingTitle": {
    color: "#1A1A1A",
    fontSize: 20,
    fontFamily: "Montserrat",
    fontWeight: 600,
    marginBottom: 24,
  },
  "& .billingDetailItemContainer": {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    color: "#1A1A1A",
    fontSize: 16,
    fontFamily: "Montserrat",
    fontWeight: 400,
    marginBottom: 16,
  },
  "& .billingDetailSeperator": {
    width: "100%",
    height: 1,
    background: "#ECECEC",
    marginBottom: 24,
    marginTop: 24,
  },
  "& .billingSubTotalContainer": {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    color: "#1A1A1A",
    fontSize: 16,
    fontFamily: "Montserrat",
    fontWeight: 600,
  },
  "& .orangePointsBoxContainer": {
    padding: 16,
    borderRadius: 8,
    background: "#EC4E20",
    color: "white",
  },
  "& .orangePointTitleContainer": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
  },
  "& .orangePointText": {
    fontSize: 14,
    fontWeight: 400,
    marginBottom: 24,
  },
  "& .orangePointBtn": {
    padding: "10px 16px",
    background: "white",
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 600,
    color: "#204B9C",
    width: 110,
    textAlign: "center",
  },
  "& .orangeCongratsBoxContainer": {
    padding: "24px 50px",
    borderRadius: 8,
    background: "#EC4E20",
    color: "white",
    fontSize: 13,
    fontWeight: 500,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  "& .orangeCongratsTitle": {
    fontSize: 16,
    fontWeight: 600,
  },
  "& .amountTextContainer": {
    display: "flex",
    width: 235,
    height: 48,
    padding: "12px 20px 12px 10px",
    alignItems: "center",
    fontSize: 16,
    fontWeight: 500,
    color: "#4D4D4D",
    borderRadius: 12,
    border: "1px solid #ECECEC",
  },
  "& .amountTextContainerWithPayAll": {
    display: "flex",
    width: 200,
    height: 48,
    padding: "12px 20px 12px 10px",
    alignItems: "center",
    fontSize: 16,
    fontWeight: 500,
    color: "#4D4D4D",
    borderRadius: 12,
    border: "1px solid #ECECEC",
  },
  "& .usablePointsContainer": {
    width: "296px",
    flexShrink: 0,
    borderRadius: "8px",
    background: "#EC4E20",
    padding: "16px",
    display: "flex",
    flexDirection: "column",
  },
  "& .flexCenterBetween": {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
  },
  "& .usablePoints": {
    color: "#FFF",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontWeight: 600,
  },
  "& .points": {
    color: "#FFF",
    fontFamily: "Montserrat",
    fontSize: "18px",
    fontWeight: 700,
  },
  "& .pointsMessage": {
    color: "#FFF",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontWeight: 400,
    marginTop: 12,
    marginBottom: 24,
  },
  "& .diamond": {
    width: "92px",
    height: "86px",
    flexShrink: 0,
    opacity: 0.1,
    position: "absolute",
  },
  "& .absolute": {
    position: "absolute",
  },
  "& .afterRedeemContainer": {
    width: "296px",
    flexShrink: 0,
    borderRadius: "8px",
    background: "#EC4E20",
    padding: "24px",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
  },
  "& .congrats": {
    color: "#FFF",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontWeight: 600,
    marginBottom: 8,
  },
  "& .afterRedeemMessagesContainer": {
    color: "#FFF",
    fontFamily: "Montserrat",
    fontSize: "13px",
    fontWeight: 500,
    marginBottom: 12,
  },
  "& .iconPointContainer": {
    display: "flex",
    gap: 8,
  },
  "& .pointsRedeemMessage": {
    marginBottom: 12,
  },
  "& .totalAmountContainer": {
    color: "#FFF",
    fontFamily: "Montserrat",
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 24,
  },
  "& .receivedAmountContainer": {
    display: "flex",
    gap: 12,
    color: "#204B9C",
    fontSize: 16,
    fontWeight: 600,
  },
  "& .totalTextContainer": {
    marginBottom: 24,
    display: "flex",
    alignItems: "center",
    gap: 14,
  },
  "& .payWithOther": {
    marginTop: 16,
    fontSize: 16,
    fontWeight: 600,
    fontFamily: "Montserrat",
    color: "#000",
  },
  "& .otherPayment": {
    cursor: "pointer",
    display: "flex",
    gap: "16px",
    borderRadius: "8px",
    background: "#FFF",
    boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.08)",
    alignItems: "center",
    paddingRight: "16px",
  },
  "& .remainingPaymentContainer": {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    marginTop: 16,
  },
  "& .disablePayButton": {
    backgroundColor: "#ECECEC !important",
    cursor: "not-allowed !important",
  },
  "& .disableSecondPayMethod": {
    opacity: 0.8,
    cursor: "not-allowed",
  },
  "& .promoCodeErrorText": {
    marginBottom: 30,
  },
  "& .payOptionIcon": {
    display: "inline-block",
    width: 20,
    height: 20,
    borderRadius: "50%",
    border: "1px solid #64748B",
    marginRight: "10px",
  },
  "& .payOptioncheckedIcon": {
    display: "inline-block",
    width: 20,
    height: 20,
    borderRadius: "50%",
    border: "1px solid #64748B",
    marginRight: "10px",
  },
  "& .redeemBtnWrap": {
    display: "flex",
    justifyContent: "center",
  },
  "& .promoCode": {
    fontFamily: "Montserrat !important",
    fontSize: "14px",
    fontWeight: 600,
  },
  "& .promoCodeProductName": {
    fontFamily: "Montserrat !important",
    fontSize: "12px",
    fontWeight: 500,
    color: "#4D4D4D",
  },
  "& .verificationBox": {
    padding: "32px",
  },

  "@media (max-width: 1200px)": {
    "& .sideBarItemContainer": {
      padding: "16px",
    },
    "& .sideBarItemText": {
      fontSize: 13,
      fontWeight: 500,
    },
    "& .sideBarContainer": {
      width: 165,
    },
    "& .sideBarIconContainer": {
      marginRight: 12,
    },
    "& .amountToPayContainer": {
      width: 320,
      padding: "22px 12px 22px 16px",
    },
    "& .headerContainer": {
      marginBottom: 16,
      fontSize: "19px",
    },
    "& .paymentModalMainContainer": {
      padding: 23,
      width: 900,
    },
    "& .detailSectionContainer": {
      width: "509px",
      padding: "12px",
      marginRight: "16px",
    },
    "& .payWithOther": {
      fontSize: "14px",
    },
    "& .payAllButton": {
      fontSize: 16,
      fontWeight: 600,
      padding: "6px 10px 6px 10px",
      maxWidth: "100px",
      color: "#204B9C",
      textAlign: "center",
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
    },
    "& .billingSectionContainer": {
      padding: 12,
      width: 331,
    },
    "& .promoCodeCls": {
      fontSize: "16px !important",
    },

    "& .applyPromoCodeCls": {
      fontSize: "13px !important",
      fontFamily: "Montserrat !important",
      fontWeight: 500,
    },
    "& .applyCls": {
      borderRadius: "8px !important",
      maxWidth: "96px !important",
      width: "100% !important",
      marginLeft: "12px !important",
      lineHeight: "20px !important",
      fontWeight: "500 !important",
    },
    "& .billingTitle": {
      fontSize: 16,
      marginBottom: 16,
    },
    "& .billingDetailItemContainer": {
      fontSize: 14,
      marginBottom: 8,
      lineHeight: "22px",
    },
    "& .billingSubTotalContainer": {
      fontSize: 14,
      fontWeight: 700,
    },
    "& .billingDetailSeperator": {
      width: "100%",
      height: 1,
      background: "#ECECEC",
      marginBottom: 16,
      marginTop: 16,
    },
    "& .payWithOtherTitle": {
      fontSize: 14,
    },
    "& .remainingPaymentContainer": {
      marginTop: 0,
    },
    "& .payMethodTitle": {
      fontSize: 13,
      fontWeight: 500,
    },
    "& .payWithamountPayableString": {
      fontSize: 13,
      fontWeight: 500,
    },
    "& .promoCodeErrorText": {
      fontSize: "12 !important",
      fontWeight: "500 !important",
      marginBottom: 13,
    },
    "& .usablePoints": {
      fontSize: "13 !important",
      fontWeight: "600 !important",
    },

    "& .pointsMessage": {
      color: "#FFF",
      fontFamily: "Montserrat",
      fontSize: "12px",
      fontWeight: 400,
    },
    "& .usablePointsContainer": {
      width: "296px",
      flexShrink: 0,
      borderRadius: "8px",
      background: "#EC4E20",
      padding: "16px 30px",
      display: "flex",
      flexDirection: "column",
    },
    "& .redeemBtn": {
      display: "flex",
      padding: "6px 16px",
      justifyContent: "center",
      alignItems: "center",
      color: "#204B9C",
      fontSize: 14,
      fontFamily: "Montserrat",
      fontWeight: 600,
      cursor: "pointer",
      borderRadius: 8,
      background: "#FFF",
      width: "max-content",
    },
    "& .amountTextContainerSar": {
      fontSize: 14,
      fontWeight: 700,
    },
    "& .promoCodeckickBtn": {
      fontSize: 14,
      fontWeight: 600,
    },
    "& .promoCode": {
      fontSize: "13px",
    },
    "& .promoCodeProductName": {
      fontFamily: "Montserrat !important",
      fontSize: "12px",
      fontWeight: 400,
      color: "#4D4D4D",
    },
    "& .PromoSavings": {
      fontFamily: "Montserrat !important",
      fontSize: "12px",
      fontWeight: 400,
      color: "##4D4D4D",
    },
    "& .promoSavingsValue": {
      fontFamily: "Montserrat !important",
      fontSize: "12px",
      fontWeight: 400,
      color: "#000000",
    },
    "& .promoButton": {
      borderRadius: "6px !important",
      maxWidth: "96px",
      maxHeight: "32px",
    },
    "& .verificationBox": {
      padding: "12px !important",
    },
    "& .gp-tooltip": {
      display: "none",
      position: "absolute",
      top: "100%",
      left: 0,
      marginTop: 4,
      width: 250,
      background: "#fff",
      border: "1px solid #ddd",
      borderRadius: 8,
      padding: 10,
      boxShadow: "0px 3px 10px rgba(0,0,0,0.15)",
      zIndex: 100,
      fontSize: 12,
      pointerEvents: "none",
    },

    "& .gp-name:hover + .gp-tooltip": {
      display: "block",
    },
  },
});
// Customizable Area End
